window._ = require('lodash');
import {createApp} from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import moshaToast from 'mosha-vue-toastify';
import {createStore} from "vuex";
import {ZiggyVue} from 'ziggy';
import {Ziggy} from '../ziggy';
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker';
import "./bootstrap.js";
import VueAxios from "vue-axios";
import axios from "axios";

import "./owl";
import "./splide";
import "./wiki";
import "./general";
import UserStore from "./stores/user";
import ArchiveStore from "./stores/archive";
import CartStore from "./stores/cart";
import ProductStore from "./stores/product";
import CheckoutStore from "./stores/checkout";
import GeneralStore from "./stores/general";

window.$ = window.jQuery = require('jquery');
const bootstrap = require('bootstrap');

const app = createApp({
    data(){
        return {

        };
    },
    methods: {
        async authenticate(){
            const token = this.token();
            if (token) {
                const config = {
                    headers: { Authorization: `Bearer ${token}` }
                };
                await this.axios.get(this.route('api.auth.check'), config).then(response => {
                    if (response.data.type === 'user') {
                        this.$store.commit('user/setUser', response.data.user);
                    } else {
                        this.$store.commit('user/setUser', {});
                    }
                }).catch(async error => {
                    await this.authGuest();
                });
            } else {
                await this.authGuest();
            }
        },
        async authGuest() {
            await this.axios.get('/auth-guest').then(response => {
                localStorage.setItem('_token', response.data.token);
            }).catch(error => {
                this.errorToast('خطا در اعتبارسنجی!');
            });
        },
        async initCart() {
            const token = this.token();
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            await this.axios.get(this.route('api.cart.list'), config).then(response => {
                this.$store.commit('cart/init', response.data);
            });
        }
    },
    mounted() {
        const init = async () => {
            await this.authenticate();
            await this.initCart();
        }
        init();
    }
});

const store = createStore({});
store.registerModule('user', UserStore);
store.registerModule('archive', ArchiveStore);
store.registerModule('cart', CartStore);
store.registerModule('product', ProductStore);
store.registerModule('checkout', CheckoutStore);
store.registerModule('general', GeneralStore);
app.use(store);

app.use(VueAxios,axios);
app.use(VueSweetalert2);
app.use(moshaToast);
app.use(ZiggyVue, Ziggy);

Ziggy.url = "";

app.use(Vue3PersianDatetimePicker, {
    name: 'datePicker',
    props: {
        format: "jYYYY/jMM/jDD HH:mm:ss",
        inputFormat: "jYYYY/jMM/jDD HH:mm:ss",
        local: 'fa',
        type: "datetime",
        editable: true
    }
});

app.mixin({
    methods: {
        token(){
            return localStorage.getItem('_token');
        },
        getUser(){
            if (this.$store.state.user.type==='user') {
                return this.$store.state.user.user;
            }
            return false;
        },
        isAuthenticated(){
            return this.$store.state.user.authenticated;
        },
        isLoggedIn() {
            return this.$store.getters['user/isLoggedIn'];
        },
        checkIsLoading() {
            if (! this.isLoggedIn()) {
                window.location.href = '/login';
            }
            return this.isLoggedIn();
        },
        getUsername(){
            return this.$store.getters['user/username'];
        },
        numberFormat(number){
            return new Intl.NumberFormat().format(number);
        },
        getCsrf(){
            return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        },
        assetUrl(path){
            let base_url = document.querySelector('meta[name="public-files-url"]').getAttribute('content');
            return path.indexOf('://') === -1 ? base_url+'/'+path : path;
        },
        appUrl(path){
            let base_url = document.querySelector('meta[name="public-url"]').getAttribute('content');
            return path.indexOf('://') === -1 ? base_url+'/'+path : path;
        },
        getQueryParams(param = null){
            const urlSearchParams = new URLSearchParams(window.location.search);
            let params = {};
            for (let item of urlSearchParams.entries()){

                if(param && item[0].indexOf(param)!==0)
                    continue;

                if (item[0].indexOf('[]') >= 0){
                    let key = item[0].substr(0, item[0].length - 2);
                    if (typeof params[key] === 'undefined')
                        params[key] = [];
                    params[key].push(item[1]);
                } else {
                    params[item[0]] = item[1];
                }
            }

            if(param)
                return params[param];

            return params;
        },
        serializeObjectToQuery(obj, prefix){
            let str = [];
            for (let p in obj) {
                if (obj.hasOwnProperty(p)) {
                    let k = prefix ? prefix + "[]" : p,
                        v = obj[p];
                    str.push((v !== null && typeof v === "object") ?
                        this.serializeObjectToQuery(v, k) :
                        k+"="+v);
                }
            }
            return str.join("&");
        },
        fullText(str){
            return str. replace(/(?:\ r\n|\r|\n)/g, '<br>');
        },
        errorToast(message, error) {
            if (message === null && error) {
                message = 'خطای ناشناخته: لطفا با پشتیبانی سایت تماس بگیرید.';
                message = error.message;
                if (typeof error.response !== "undefined") {
                    if (typeof error.response.message !== "undefined") {
                        message = error.response.data.message;
                    } else if (typeof error.response.data.message !== "undefined") {
                        message = error.response.data.message;
                    }
                }
            }
            this.$moshaToast(message ,{
                position: 'top-left',
                type: 'danger',
            });
        },
        successToast(message) {
            this.$moshaToast(message ,{
                position: 'top-left',
                type: 'success',
            });
        },
        isLoading() {
            return this.$store.state.general.loading;
        },
        startLoading() {
            this.$store.commit('general/setLoading', true);
        },
        endLoading() {
            this.$store.commit('general/setLoading', false);
        }
    },
});

app.component('loading', require("./components/general/Loading").default);
app.component('header-profile', require("./components/general/HeaderProfile").default);
app.component('header-cart', require("./components/cart/HeaderCart").default);
app.component('login', require("./components/login/Login").default);
app.component('profile-sidebar', require("./components/profile/ProfileSidebar").default);
app.component('profile-dashboard', require("./components/profile/ProfileDashboard").default);
app.component('profile-orders', require("./components/profile/ProfileOrders").default);
app.component('profile-wishlist', require("./components/profile/ProfileWishlist").default);
app.component('profile-waiting-list', require("./components/profile/ProfileWaitingList").default);
app.component('profile-edit', require("./components/profile/ProfileEdit").default);
app.component('filters-toggle', require("./components/archive/FiltersToggle").default);
app.component('archive-sidebar', require("./components/archive/Sidebar").default);
app.component('archive-sort', require("./components/archive/Sort").default);
app.component('archive-index', require("./components/archive/ArchiveIndex").default);
app.component('archive-pagination', require("./components/archive/Pagination").default);
app.component('add-to-cart', require("./components/cart/AddToCart").default);
app.component('single-product', require("./components/product/SingleProduct").default);
app.component('comments', require("./components/product/comments/Comments").default);
app.component('variations', require("./components/product/Variations").default);
app.component('single-product-price', require("./components/product/SingleProductPrice").default);
app.component('single-product-actions', require("./components/product/SingleProductActions").default);
app.component('cart', require("./components/cart/Cart").default);
app.component('checkout', require("./components/checkout/Checkout").default);
app.component('countdown-timer', require("./components/countdown/Countdown").default);

app.mount('#app');
